/* eslint-disable no-unused-vars */
import querystring from 'querystring'
import { post, get, createFetchTask } from '@integec/fetch-task'
import R from 'ramda'
import moment from 'moment'
import { getEffectiveJwt } from 'utils'
import { getCredentials, getAuthorization, exportData } from 'api/pgads.js'
import { DATE_FORMAT_API } from 'enum'

export const wind2TurbinePowerData = targetInfo => ({ year, month, plantid }) =>
  get(
    targetInfo,
    `wind-nerc-powerdata/get-turbine-power-data?${querystring.stringify({
      year,
      month,
      plantid,
    })}`
  )

export const exportWindTurbinePerformanceData = targetInfo => ({
  year,
  month,
  plantid,
  mode,
}) =>
  get(
    targetInfo,
    `wind-nerc-powerdata/nerc-data-export?${querystring.stringify({
      year,
      month,
      plantid,
      mode,
    })}`
  )

export const saveWind2TurbinePerformance = targetInfo => data =>
  post(targetInfo, 'wind-nerc-powerdata/save-turbine-performance')(data)
export const deleteWind2TurbinePerformance = targetInfo => data =>
  post(targetInfo, 'wind-nerc-powerdata/delete-turbine-performance')(data)

export const createTurbinePerormanceWithEvents = targetInfo => ({
  year,
  month,
  plantid,
}) =>
  get(
    targetInfo,
    `wind-nerc-powerdata/create-turbine-performance-data?${querystring.stringify(
      {
        year,
        month,
        plantid,
      }
    )}`
  )

export const windProcessEventAndPerformanceData = targetInfo => ({
  year,
  month,
  plantid,
  type = 'A',
}) =>
  get(
    targetInfo,
    `wind-nerc-powerdata/process-nerc-and-performance-events?${querystring.stringify(
      {
        year,
        month,
        plantid,
        type,
      }
    )}`
  )

export const windStoragePerformanceSave = targetInfo => data =>
  post(targetInfo, 'wind-nerc-powerdata/save-storage-performance')(data)

export const windStorageGroupSave = operationType => targetInfo => data =>
  post(
    targetInfo,
    'wind-nerc-powerdata/storage-group?optype=' + operationType
  )(data)
export const windStorageGroup = targetInfo =>
  get(targetInfo, 'wind-nerc-powerdata/storage-group')
export const windStorageGroupHelper = targetInfo =>
  get(targetInfo, 'wind-nerc-powerdata/storage-group-helper')

export const wind2Report = targetInfo => data =>
  post(targetInfo, 'wind-nerc-powerdata/wind-report')(data)
export const wind2ReportGetElements = targetInfo =>
  get(targetInfo, 'wind-nerc-powerdata/wind-report-elements')

export const wind2ReportExportBlob = targetInfo => (
  data,
  qryParam,
  filename
) => otherFunc => {
  const URL = `${
    targetInfo.baseUrl
  }/wind-nerc-powerdata/export-pdf?${querystring.stringify(qryParam)}`
  return fetch(`${URL}`, {
    method: 'POST',
    ignoreAuth: false,
    ...getCredentials(targetInfo),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/octet-stream',
      ...getAuthorization(targetInfo),
    },
    body: JSON.stringify(data),
  })
    .then(response => response.blob())
    .then(blob => exportData(blob, 'application/pdf', filename))
    .then(b => (otherFunc ? otherFunc(b) : b))
}

export const wind2FilePlants = targetInfo => req =>
  get(targetInfo, `wind2-file-creation/plant?${querystring.stringify(req)}`)

export const wind2FileSubgroup = targetInfo => req =>
  get(targetInfo, `wind2-file-creation/subgroup?${querystring.stringify(req)}`)

export const wind2FileSubgroupPerformance = targetInfo => req =>
  get(
    targetInfo,
    `wind2-file-creation/subgroup-performance?${querystring.stringify(req)}`
  )

export const wind2FileEvents = targetInfo => req =>
  get(targetInfo, `wind2-file-creation/event?${querystring.stringify(req)}`)

export const wind2FileEventSubgroupPerformance = targetInfo => req =>
  get(
    targetInfo,
    `wind2-file-creation/event-subgroup-performance?${querystring.stringify(
      req
    )}`
  )
export const wind2FileStorage = targetInfo => req =>
  get(
    targetInfo,
    `wind2-file-creation/storage-by-plant?${querystring.stringify(req)}`
  )

export const wind2FileStoragePerformance = targetInfo => req =>
  get(
    targetInfo,
    `wind2-file-creation/storage-performance?${querystring.stringify(req)}`
  )

export const resubmitWind2SubGroupPerf = targetInfo => data =>
  post(targetInfo, 'wind2-file-creation/subgroup-perf/resubmit')(data)

export const resubmitWind2SubGroup = targetInfo => data =>
  post(targetInfo, 'wind2-file-creation/subgroup/resubmit')(data)

export const resubmitWind2Plant = targetInfo => data =>
  post(targetInfo, 'wind2-file-creation/plant/resubmit')(data)

export const resubmitWind2Event = targetInfo => data =>
  post(targetInfo, 'wind2-file-creation/nerc-event/resubmit')(data)

export const resubmitWind2EnergyStorage = targetInfo => data =>
  post(targetInfo, 'wind2-file-creation/storage-group/resubmit')(data)

export const resubmitWind2StoragePerformance = targetInfo => data =>
  post(targetInfo, 'wind2-file-creation/storage-performance/resubmit')(data)

export const getwind2EventTypes = targetInfo =>
  get(targetInfo, 'wind-nerc-powerdata/get-event-type')

export const getWind2PiDataImport = targetInfo => ({
  start,
  end,
  byStartTime = false,
}) =>
  get(
    targetInfo,
    `wind-nerc-powerdata/wind2-pi-import?${querystring.stringify({
      start: start.format(DATE_FORMAT_API),
      end: end.format(DATE_FORMAT_API),
      byStartTime,
    })}`
  )

export const saveWind2PiDataImport = targetInfo => data =>
  post(targetInfo, 'wind-nerc-powerdata/wind2-pi-import/save')(data)

export const cancelWind2PiDataImport = targetInfo => data =>
  post(targetInfo, 'wind-nerc-powerdata/wind2-pi-import/cancel')(data)

export const getWind2DataIntervals = targetInfo => ({ transId }) =>
  get(
    targetInfo,
    `wind-nerc-powerdata/wind2-intervals?${querystring.stringify({
      transId,
    })}`
  )

export const getwind2MissingData = targetInfo => ({ plant, start, end }) =>
  get(
    targetInfo,
    `wind-nerc-powerdata/wind2-missing-data?${querystring.stringify({
      plant,
      start: start.format(DATE_FORMAT_API),
      end: end.format(DATE_FORMAT_API),
    })}`
  )

export const getwind2StorageGroupFormation = targetInfo =>
  get(targetInfo, 'wind-nerc-powerdata/wind2-storage-group-formation')

export const updateMultipleCaucecodeTurbineEvent = targetInfo => data =>
  post(targetInfo, 'wind-nerc-powerdata/turbine-multicausecode-update')(data)
